module.exports = __webpack_public_path__ + "media/images/ministerio_economia-41fa6f8fe0638f6f579e7bb3bc857277.svg";